import React from "react";
import { Result } from "antd";
import { Localize } from "components/service";
import { SmartHomeButton } from "components/permissions";

const Page403 = () =>
{
    return (
        <div className="page-holder bg-white">
            <Result
                status="403"
                title="403"
                subTitle={<Localize>PAGES.Text_403</Localize>}
                extra={<SmartHomeButton />}
            />
        </div>
    );
};

export default Page403;